import { useMortgageRatesQuery } from "web_myplann/Api/Calculators/useMortgageRatesQuery";
import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";

export const useInspirationStepLoading = () => {
	const { isLoading: isBalanceLoading } = useFinanceEntries();
	const { isLoading: isRatesLoading } = useMortgageRatesQuery();

	return { isLoading: isBalanceLoading || isRatesLoading };
};
